import React, { useEffect } from "react";
//*import { URInput } from "../../../shared/widgets/input";
import styles from "./chatEmoji.module.scss";
//*import mail2 from "../../../styles/images/1b.png";
import Picker, { SKIN_TONE_MEDIUM_DARK } from 'emoji-picker-react';
import { URChatGIF } from "../../../shared/widgets/chatGif";
import { URChatSticker } from "../../../shared/widgets/chatSticker";

function URChatEmoji(props:any) {
  const [isEmojiVisible, setEmojiVisible] = React.useState(true);
  const [isGifVisible, setGifVisible] = React.useState(false);
  const [isStrickerVisible, setStrickerVisible] = React.useState(false);
  const [getEmojiStyle, setEmojiStyle] = React.useState('emojiIcon active');
  const [getGifStyle, setGifStyle] = React.useState('gifIcon');
  const [getStrickerStyle, setStrickerStyle] = React.useState('stickerIcon');;

  useEffect(() => {
    setEmojiVisible(true);
    setGifVisible(false);
    setStrickerVisible(false);
    setEmojiStyle('emojiIcon active');
    setGifStyle('gifIcon')
    setStrickerStyle('stickerIcon');
  },[props?.isEditing !== false]);
  
  const onEmojiClick=(event:any,emojiData:any)=>{

    if(event.target){
      props.handleEmoji(emojiData.emoji);
    }
    
  };
  const onEmojiEnableClick=()=>{
    setEmojiVisible(true);
    setGifVisible(false);
    setStrickerVisible(false);
    setEmojiStyle('emojiIcon active');
    setGifStyle('gifIcon')
    setStrickerStyle('stickerIcon');
    
  };
  const onGifEnableClick=()=>{
    setEmojiVisible(false);
    setGifVisible(true);
    setStrickerVisible(false);
    setEmojiStyle('emojiIcon');
    setGifStyle('gifIcon active')
    setStrickerStyle('stickerIcon');
    
  };
  const onStrickerEnableClick=()=>{
    setEmojiVisible(false);
    setGifVisible(false);
    setStrickerVisible(true);
    setEmojiStyle('emojiIcon');
    setGifStyle('gifIcon')
    setStrickerStyle('stickerIcon active');
    
  };

  return (
    <>
      <div className={styles.popOverContainer}>
        <div className={styles.topHeadersec}>
        {isEmojiVisible === true && (
          <Picker onEmojiClick={onEmojiClick}/>
          )
        }
        {isGifVisible === true && (
          <>
              <URChatGIF />
          </>
        )
        }
        {isStrickerVisible === true && (
          <>
              <URChatSticker />
          </>
        )
        }
          <div className="popoverBottom">
            <span className={getEmojiStyle}  onClick={()=>onEmojiEnableClick()}></span>
           {props?.isEditing === false &&  <span className={getGifStyle} onClick={()=>onGifEnableClick()}></span> }
           {props?.isEditing === false && <span className={getStrickerStyle} onClick={()=>onStrickerEnableClick()}></span> }
          </div>
          {/* <div className={styles.listdrapdrop}>
          <ul className={styles.toplistIcon}>             
              <li className={styles.active}>
                <span className="icon_clock"></span>
              </li>
              <li>
                <span className="icon_smile"></span>
              </li>
              <li>
                <span className="icon_leaf"></span>
              </li>
              <li>
                <span className="icon_food"></span>
              </li>
              <li>
                <span className="icon_plane"></span>
              </li>
              <li>
                <span className="icon_run"></span>
              </li>
              <li>
                <span className="icon_light"></span>
              </li>
              <li>
                <span className="icon_ring"></span>
              </li>
              <li>
                <span className="icon_flagoutline"></span>
              </li>
          </ul>     
          </div> */}
        </div>

      </div>
    </>
  );
}

export {
  URChatEmoji
};